import React, {  Component } from 'react';

export default class ConfirmApproveRequestDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog("ConfirmApproveRequestDialog", false);
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Confirm Approve Request</h2>
					<p>Are you sure you want to approve this user for access to CustomerNet?</p>
					<p><b>{this.props.firstName} {this.props.lastName}</b></p>
                    <a className="blueButton noButton" onClick={this.closeDialog.bind(this)}>Cancel</a>
					<a className="blueButton yesButton" onClick={this.props.handleApproveOrRejectServiceCall.bind(this, "Approved")}>Yes</a>
                 </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmApproveRequestDialog.js